
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DamageRepairInfo extends Vue {
    goToHomePage() {
        this.$emit('goToHomePage', { vendorLocationUrl: `https://${this.$t('label.damageRepairUrl')}/` });
    }
}
